module.exports = __webpack_public_path__ + "media/img/img-about-2-ddf7e7c6.JPG";